<!--suppress JSUnresolvedVariable -->
<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">相册管理</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <el-button @click="addPhotoAlbum(0)" size="small" type="primary" plain>
          新增照片
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="photoAlbumList"
        tooltip-effect="dark"
        style="width: 100%;"
        height="417"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          prop="photoId"
          label="照片ID"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column prop="photoUrl" label="缩略图" align="center">
          <template slot-scope="scope">
            <img
              style="width: 65px;height: 65px;"
              :src="scope.row.photoUrl"
              alt="缩略图"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button
              @click="editPhotoAlbum(scope.row.photoId)"
              type="primary"
              plain
              size="small"
              >编辑
            </el-button>
            <el-popconfirm
              placement="top"
              icon="el-icon-info"
              iconColor="red"
              title="确定要删除吗？"
              @onConfirm="deleteById(scope.row.photoId)"
            >
              <el-button
                type="danger"
                slot="reference"
                plain
                class="ml-1"
                size="small"
              >
                移除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt-3"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "PhotoAlbum",
  data() {
    return {
      photoAlbumList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted() {
    this.getPhotoAlbumList();
  },
  methods: {
    getPhotoAlbumList() {
      this.loading = true;
      this.axios
        .get("/photoAlbum/getPhotoAlbumList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.photoAlbumList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getPhotoAlbumList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPhotoAlbumList();
    },
    editPhotoAlbum(photoId) {
      this.$router
        .push({ name: "PhotoAlbumForm", params: { photoId: photoId } })
        .catch();
    },
    addPhotoAlbum(photoId) {
      this.$router
        .push({ name: "PhotoAlbumForm", params: { photoId: photoId } })
        .catch();
    },
    deleteById(photoId) {
      this.axios
        .delete("/photoAlbum/deletePhotoAlbum", {
          params: {
            photoId: photoId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.getPhotoAlbumList();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
